<template>
    <div>
        <div class="container-fluid">
            <div class="row el-table__body JY-order-detail JY-order-detail-b">
                <div class="col-sm-10 col-md-10 JY-list-a" style="margin: 20px auto;">
                    <el-form label-width="180px" class="el-form" style="width: 100% !important; ">
                         <el-form-item label="订单状态" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.OrderStatus}}</span>
                        </el-form-item>
                        <el-form-item label="出发地" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.ChuFaDi}}</span>
                        </el-form-item>
                        <el-form-item label="到达地" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.DaoDaDi}}</span>
                        </el-form-item>
                        <el-form-item label="承运人确认" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.Status}}</span>
                        </el-form-item>
                        <el-form-item label="运单数" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.YunDanNum}}</span>
                        </el-form-item> 
                        <el-form-item label="承运人" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.ChengYunUserName}}</span>
                        </el-form-item>
                        <el-form-item label="价格(元)" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>￥{{item.BaoJiaLeiXing=='按吨'?(formatNumber(item.DanJia)+'(总计)'):(formatNumber(item.DanJia))}}</span>
                        </el-form-item>
                        <el-form-item label="预计承运" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.BaoJiaLeiXing=='按吨'?(item.DanJia*item.YuJiDun_Car_Num)+'吨':''+item.YuJiDun_Car_Num+'车'}} </span>
                        </el-form-item>
                         <el-form-item label="总车数" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.TotalCarNum}}</span>
                        </el-form-item>
                        <el-form-item label="预计劳务费" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>￥{{formatNumber(item.YuJiLaoWuFei)}}</span>
                        </el-form-item>
                        <el-form-item label="每车可接受油卡金额" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>￥{{formatNumber(item.YouKaJinE)}}</span>
                        </el-form-item>
                        <el-form-item label="签订协议时间" style="border-bottom: 1px solid #ddd !important; width: 100% !important;">
                            <span>{{item.CreateTime}}</span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import util from "../libs/util";
    export default {
        props: {
            item: Object,
        },
        methods:{
            formatNumber(n){
                return util.getThousandNumber(n)
            }
        },
        mounted() {}
    };
</script>
<style>
    .tip {
        width: 100%;
        text-align: center;
        padding-bottom: 20px;
    }
    .el-dialog__body {
        padding-top: 0px !important;
    }
    .el-table__body .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 65%;
    }
    .el-table__body .el-form-item__label {
        width: 200px;
        color: #99a9bf;
    }
    .imgs img {
        width: 240px;
        height: 160px;
        border-radius: 2px;
        object-fit: cover;
        cursor: pointer;
    }
    .price {
        font-size: 22px !important;
        margin-right: 20px;
    }
</style>





// WEBPACK FOOTER //
// src/components/agreement.vue